module.exports = __webpack_public_path__ + "img/Weapon_117.3b3687d3.png";